import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = {
  path: '/true-budget/',
  exact: true,
  enableLooseEtag: true,
  page: getLoadablePage(() => import(/* webpackChunkName: "true_budget_page" */ '../pages/true-budget/true-budget')),
  chunkName: 'true_budget_page',
};
